export enum StudentEksportStatus {
  WTrakcie = 1,
  Sukces = 2,
  Ostrzezenie = 3,
  Blad = 4,
}
